import { useEffect, useState } from 'react';
import { IntlProvider, MessageFormatElement } from 'react-intl';

const loadLocaleData = (locale: string) => {
  switch (locale) {
    case 'en':
      return import('@config/locales/en.json');
    case 'fr':
      return import('@config/locales/fr.json');
    case 'ro':
      return import('@config/locales/ro.json');
    case 'zh':
      return import('@config/locales/zh.json');
    default:
      return import('@config/locales/ru.json');
  }
};

export const Locales: React.FC<React.PropsWithChildren> = ({ children }) => {
  const locale = 'ru'; //@todo connect redux - useTypedSelector(getLocale);

  const [messages, setMessages] = useState<
    Record<string, string> | Record<string, MessageFormatElement[]> | undefined
  >();

  useEffect(() => {
    loadLocaleData(locale).then(
      (d: {
        default:
          | Record<string, string>
          | Record<string, MessageFormatElement[]>
          | undefined;
      }) => {
        setMessages(d.default);
      }
    );
  }, [locale]);

  return (
    <>
      {messages && (
        <IntlProvider
          locale={locale || 'ru'}
          defaultLocale="ru"
          messages={messages}
        >
          {children}
        </IntlProvider>
      )}
    </>
  );
};
